import { useSelector } from "react-redux"
import ConsultaDeAcesso from "../ConsultaDeAcesso";
import Dashboard from "../Dashboard";
import Equipamentos from "../Equipamentos";
import SolicitacaoAcesso from "../SolicitacaoAcesso";
import SolicitacaoAcessoAnalise from "../SolicitacaoAcessoAnalise";
import SolicitacaoVistoria from "../SolicitacaoVistoria";
import SolicitacaoVistoriaAnalise from "../SolicitacaoVistoriaAnalise";
import DashboardGeracao from "../DashboardGeracao";
import CompInfraestrutura from "../CompInfraestrutura";
import Ocupante from "../Ocupante";
import ConsultaDisponibilidade from "../ConsultaDisponibilidade";
import SolicitacaoCompartilhamento from "../SolicitacaoCompartilhamento";
import ListaAnalisesAntigas from "../SolicitacaoCompartilhamento/Cadastro/Analises";
import SolicitacaoFiscalizacao from "../SolicitacaoFiscalizacao";
import SolicitacaoFiscalizacaoAnalise from "../SolicitacaoFiscalizacao/SolicitacaoFiscalizacaoAnalise";
import { Downloads } from "../Downloads/Downloads";
import ProjetosParticulares from '../ProjetosParticulares'
import ConsultaPrevia from "../ConsultaPrevia";
import ConsultaPreviaAnalise from "../ConsultaPreviaAnalise";
import AnaliseProjeto from "../AnaliseProjeto";
import AnaliseProjetoAnalise from "../AnaliseProjetoAnalise";

const TabPanels = [
    { render: () => <Dashboard /> }, //0
    { render: () => <Equipamentos /> }, //1
    { render: () => <ConsultaDeAcesso /> },  //2
    { render: () => <SolicitacaoAcesso /> }, //3
    { render: () => <SolicitacaoVistoria /> }, //4
    { render: () => <SolicitacaoAcessoAnalise /> }, //5
    { render: () => <SolicitacaoVistoriaAnalise /> }, //6
    { render: () => <DashboardGeracao /> }, //7
    { render: () => <CompInfraestrutura /> }, //8
    { render: () => <Ocupante /> }, //9
    { render: () => <ConsultaDisponibilidade /> }, //10
    { render: () => <SolicitacaoCompartilhamento /> }, //11
    { render: () => <ListaAnalisesAntigas /> }, //12
    { render: () => <SolicitacaoFiscalizacao /> }, //13
    { render: () => <SolicitacaoFiscalizacaoAnalise /> }, //14
    { render: () => <Downloads /> }, //15
    { render: () => <ProjetosParticulares /> }, //16
    { render: () => <ConsultaPrevia /> }, //17
    { render: () => <ConsultaPreviaAnalise/> }, //18
    { render: () => <AnaliseProjeto/> }, //19
    { render: () => <AnaliseProjetoAnalise/> }, //20
]

const TabPanel = ({ children, value, index, x, ...other }) => {

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <>
                    {TabPanels[x].render()}
                </>
            )}
        </div>
    )
}

const TabsManager = () => {
    const { tabs, tabsIndex } = useSelector(state => state.tabs);

    return (
        <div style={{ width: "100%", height: "100%" }}>
            {tabs && tabs.map((tab) => (
                <TabPanel key={tab.Codigo} index={tab.Codigo} value={tabsIndex} x={tab.Aba} />
            ))}
        </div>
    )
}

export { TabsManager }